export type IEasingFunction = (number) => number;
export const linear: IEasingFunction = t => t;
export const easeInQuad: IEasingFunction = t => Math.pow(t, 2);
export const easeOutQuad: IEasingFunction = t => 1 - easeInQuad(1 - t);
export const easeInOutQuad: IEasingFunction = t => t < 0.5 ? easeInQuad(t * 2) / 2 : easeOutQuad(t * 2 - 1) / 2 + 0.5;
export const easeInCubic: IEasingFunction = t => Math.pow(t, 3);
export const easeOutCubic: IEasingFunction = t => 1 - easeInCubic(1 - t);
export const easeInOutCubic: IEasingFunction = t => t < 0.5 ? easeInCubic(t * 2) / 2 : easeOutCubic(t * 2 - 1) / 2 + 0.5;
export const easeInQuart: IEasingFunction = t => Math.pow(t, 4);
export const easeOutQuart: IEasingFunction = t => 1 - easeInQuart(1 - t);
export const easeInOutQuart: IEasingFunction = t => t < 0.5 ? easeInQuart(t * 2) / 2 : easeOutQuart(t * 2 - 1) / 2 + 0.5;
export const easeInQuint: IEasingFunction = t => Math.pow(t, 5);
export const easeOutQuint: IEasingFunction = t => 1 - easeInQuint(1 - t);
export const easeInOutQuint: IEasingFunction = t => t < 0.5 ? easeInQuint(t * 2) / 2 : easeOutQuint(t * 2 - 1) / 2 + 0.5;
